<div class="flex flex-column w-full h-full gap-3 p-4">
  <div class="block align-items-center justify-content-between px-2 sm:flex">
    <p class="font-semibold text-xl" style="color: #163960">
      <i class="pi pi-angle-right" style="color: #163960; font-size: 1rem"></i>
      {{ titleText }}
    </p>
    <div *ngIf="rol === 'Trabajador' || rol === 'Empleador' || rol === 'Representante gremial'">
      <app-claim-types></app-claim-types>
    </div>
  </div>

  <ng-container>
    <app-claims-table *ngIf="!isCommisionRol"></app-claims-table>
    <app-claims-comision-table
      *ngIf="isCommisionRol"
    ></app-claims-comision-table>
  </ng-container>
</div>
